import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'RELIEF_UPDATE',
    smsDelete : 'RELIEF_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        relief_list: [],

        submitSuccess: false,
        reliefLoading: false,
        reliefError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_RELIEF(state, relief) {
            state.relief_list = relief;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        RELIEF_LOADING (state, loading) {
            state.reliefLoading = loading;
        },

        RELIEF_ERROR (state, hasError) {
            state.reliefError = hasError;
        }
    },

    actions: {
        async addRelief ({commit, dispatch}, payload) {
            commit('RELIEF_LOADING', true);
            commit('RELIEF_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_relief, payload.relief, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchRelief')
                return response

            } catch (e) {
                commit('RELIEF_ERROR', true);
            } finally {
                commit('RELIEF_LOADING', false);
            }
        },

        async fetchRelief ({ commit }) {
            commit('RELIEF_LOADING', true);
            commit('RELIEF_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.relief_list, config);
                let response = result.data
                commit('SET_RELIEF', response.data);

            } catch(error) {
                commit('RELIEF_ERROR', true);
            } finally {
                commit('RELIEF_LOADING', false);
            }
        },

        async getReliefsByType ({ commit }, payload) {
            commit('RELIEF_LOADING', true);
            commit('RELIEF_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.relief_list_by_type + payload, config);
                let response = result.data
                commit('SET_RELIEF', response.data);

            } catch(error) {
                commit('RELIEF_ERROR', true);
            } finally {
                commit('RELIEF_LOADING', false);
            }
        },

        async updateRelief ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.post(V1API.update_relief + payload.id, payload.relief, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchRelief')
                return response

            } catch (e) {
                commit('RELIEF_ERROR', true);
            } finally {
                commit('RELIEF_LOADING', false);
            }
        },
        
        async deleteRelief({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.relief_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchRelief')
            return response
        }
    },

    getters: {}
}
